// cSpell:disable
export const supportedLocales = {
	en: "English",
	ar: "عربي",
	ar_kw: "عربي - الكويت"
};

export const fallbackLocale = "en";
